<div class="modal-header">
    <h3 class="modal-title text-center">Create new expense</h3>
</div>
<div class="modal-body">

    <magieno-input-money-field
            [advancedFormControl]="this.form.formElements.amount | asAdvancedFormControl"></magieno-input-money-field>

    <div class="mt-3">
        <magieno-datepicker

                [advancedFormControl]="this.form.formElements.transactionDate | asAdvancedFormControl">
            <i calendarIcon class="bi bi-calendar"></i>
        </magieno-datepicker>
    </div>

    <div class="mt-3">
        <magieno-input-text-field
                [advancedFormControl]="this.form.formElements.location | asAdvancedFormControl"></magieno-input-text-field>
    </div>

    <div class="mt-3">
        <magieno-textarea
                [advancedFormControl]="this.form.formElements.description | asAdvancedFormControl"></magieno-textarea>
    </div>

    <div class="mt-3">
        <magieno-search-dropdown-select
                [advancedFormControl]="this.form.formElements.labels | asAdvancedFormControl"></magieno-search-dropdown-select>

    <div class="mt-3">
        <magieno-search-dropdown-select
                [advancedFormControl]="this.form.formElements.categories | asAdvancedFormControl">
          <span create-new-text>New Category </span>
        </magieno-search-dropdown-select>
    </div>
</div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="createExpense()" [disabled]="isCreateExpenseDisabled">
    <span *ngIf="!isCreateExpenseDisabled">
      <i class="bi bi-plus"></i> Create expense
    </span>
        <span *ngIf="isCreateExpenseDisabled">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      Creating...
    </span>
    </button>
    <button type="button" class="btn btn-white" (click)="activeModal.close()">Cancel</button>
</div>
